<script lang="ts">
  import Card from "../../lib/ui/Card.svelte";

  const STEPS: { title: string; say: string }[] = [
    {
      title: "1. Who + where from (GDPR Art. 14)",
      say: "Bună ziua, sunt Constantin de la Pretaro. Am găsit firma dvs. în registrul public ONRC, la comerț cu ridicata de echipamente. Aveți un minut?",
    },
    {
      title: "2. Qualify",
      say: "Cine se ocupă de cererile de ofertă? Câte cereri primiți pe săptămână și la câți furnizori verificați prețurile?",
    },
    {
      title: "3. Pitch",
      say: "Pretaro preia cererea de ofertă a clientului, toate pozițiile odată, caută în magazinele online ale furnizorilor la care aveți cont, direct în browserul dvs., deci vede prețurile dvs. nete reale, și alege varianta cea mai ieftină pe stoc. Export CSV. Durează minute, nu ore.",
    },
    {
      title: "4. Ask for consent",
      say: "Vă pot trimite pe email linkul la demo-ul live de 2 minute, fără instalare? Pe ce adresă?",
    },
  ];
</script>

<Card title="Call script" subtitle="60 seconds, Romanian. A human call, never a cold email.">
  <ol class="m-0 p-0 list-none flex flex-col gap-3">
    {#each STEPS as s (s.title)}
      <li>
        <div class="text-xs font-bold uppercase tracking-wide text-muted">{s.title}</div>
        <p class="m-0 mt-1 text-sm leading-relaxed">„{s.say}”</p>
      </li>
    {/each}
  </ol>
  <ul class="mt-4 mb-0 pl-4.5 text-xs text-muted flex flex-col gap-1">
    <li><strong class="text-ink">Yes, send info</strong> → status Interested; note the email + “consent by phone, date”. Only then email.</li>
    <li><strong class="text-ink">Not now</strong> → Called + a follow-up date.</li>
    <li><strong class="text-ink">Don’t call again</strong> → Not interested. Objection is absolute (Art. 21): never contact again.</li>
    <li>Goal: calls → “send me info” → demo → trial. Aim for 10 calls a day.</li>
  </ul>
</Card>
